import {
  ActionsGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FlatButton,
  Input,
  RaisedButton,
  TitleText,
} from "@evergis/ui";
import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDialogInfo } from "../../../hooks/useDialogs";

export interface AddByLinkOptions {
  onApply: (link: string) => void;
}

export const AddByLink: FC = () => {
  const { t } = useTranslation("dialogs");

  const { options: dialogOptions, closeDialog } = useDialogInfo<string[], AddByLinkOptions>(false);
  const { onApply } = dialogOptions;

  const [link, setLink] = useState("");

  const onAdd = useCallback(() => {
    onApply(link);
    closeDialog();
  }, [closeDialog, onApply, link]);

  return (
    <Dialog onClick={e => e.preventDefault()} hasClickAway={false} isOpen maxWidth="40rem" onCloseRequest={closeDialog}>
      <DialogTitle>
        <TitleText>{t("addByLink.addFileByLink")}</TitleText>
      </DialogTitle>
      <DialogContent>
        <Input
          width="100%"
          label={t("addByLink.link")}
          placeholder={t("addByLink.link")}
          value={link}
          onChange={event => setLink(event.target.value)}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton primary onClick={onAdd} disabled={!link}>
            {t("actions.add", { ns: "common" })}
          </RaisedButton>
          <FlatButton onClick={closeDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
